import { FC, useState } from 'react';
import { useStyles } from './styles';
import { Button } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import { DateRangePicker as RawDateRangePicker } from 'materialui-daterange-picker';
import { defaultRanges } from './DefaultRanges';
import { DateRangePickerProps } from './types';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { wrapperTheme } from './styles';

const normalizeRange = (range: DateRangePickerProps['initialRange']) => {
  if (!range?.startDate || !range?.endDate) {
    return range;
  }

  if (range.startDate > range.endDate) {
    return {
      startDate: range.endDate,
      endDate: range.startDate,
    };
  }

  return range;
};

export const DateRangePicker: FC<DateRangePickerProps> = ({ initialRange, customRanges, onChange }) => {
  const classes = useStyles();

  const [open, setOpen] = useState<boolean>(false);

  const toggle = () => setOpen(!open);
  const safeInitialRange = normalizeRange(initialRange);
  const safeCustomRanges = customRanges?.map((range) => normalizeRange(range) || range) || [];

  return (
    <div>
      <Button className={classes.dateRangeButton} startIcon={<DateRangeIcon />} onClick={toggle}>
        Date Range
      </Button>
      <ThemeProvider theme={wrapperTheme}>
        <RawDateRangePicker
          wrapperClassName={classes.dateRangePopUp}
          open={open}
          toggle={toggle}
          initialDateRange={safeInitialRange}
          definedRanges={defaultRanges.concat(safeCustomRanges as [])}
          onChange={onChange}
          closeOnClickOutside
        />
      </ThemeProvider>
    </div>
  );
};
